import setupValidationConfig from './config';
import setupValidationRules from './rules';

function initValidation() {
    setupValidationRules();
    setupValidationConfig(); // optional
}

export default initValidation;
